/** Newest first; does not mutate the input array. */
export function sortDesignsByCreatedAt(designs) {
  return [...(designs || [])].sort(
    (a, b) => new Date(b.created_at) - new Date(a.created_at),
  );
}
